import React from 'react';
import {observer} from "mobx-react";
import {PropositionBetsDetailsModuleAsync} from "../../../modules/proposition-bets-details-module/components/proposition-bets-details-module.async";
import {PROPOSITION_BETS} from "../../proposition-bets-widget/proposition-bets-widgets.consts";

export const PredictionWidgetDetailsPopup = observer(({controller, source}) => {
  const {state} = controller;
  const {popupDisplay, isVisible} = state;
  const {athleteId, lineTypeId, gameId} = popupDisplay;

  const popupProps = {
    onPopupClose: () => controller.action(PROPOSITION_BETS.ACTION_TYPES.onPopupClick),
    athleteId,
    lineTypeId,
    gameId,
    isPrediction: true,
    source
  }

  return isVisible ? <PropositionBetsDetailsModuleAsync {...popupProps}/> : null
});
